import { NewPaymentLinkForm } from '../hooks/useCreatePaymentLinkForm';

// Wire contract for POST {PAYMENT_LINKS_ENDPOINTS.create}, as proxied by the BFF to the
// downstream payments gateway (POST /gateway/api/v2/link). `date` is the link's optional
// expiration, expected in ISO 8601 (e.g. 2026-03-10T00:00:00.000Z).
export interface CreatePaymentLinkRequest {
  idMerchant: string;
  concept: string;
  amount: number;
  date?: string;
}

export interface CreatePaymentLinkResponseData {
  id: number;
  token: string;
  concept: string;
  // The real BFF response serializes this as a string (e.g. "40"), not a number.
  amount: string;
  expire_date?: string;
  // Public, shareable URL returned by Broxel itself on creation. Authoritative —
  // Broxel owns this domain/path, so it's used as-is instead of being rebuilt client-side.
  url: string;
}

export interface CreatePaymentLinkResponse {
  success: boolean;
  message: string;
  data: CreatePaymentLinkResponseData;
}

export const toCreatePaymentLinkRequest = (form: NewPaymentLinkForm): CreatePaymentLinkRequest => ({
  idMerchant: form.id_merchant,
  concept: form.concept,
  amount: Number(form.amount),
  date: form.has_expiration_date && form.expiration_date ? form.expiration_date.toISOString() : undefined,
});
